import React, { useState } from 'react';
import { Card } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { CustomerInsights } from 'components/insights/customer-insights';
import { FleetInsights } from 'components/insights/fleet-insights';
import { EInsightsTab, insightsTabs, INSIGHTS_ACTIVE_TAB_KEY } from './constants';
import { getInitialInsightsTab } from './utils';

export const Home: React.FC = () => {
  const [activeTab, setActiveTab] = useState<EInsightsTab>(getInitialInsightsTab);

  const onTabChange = (key: string) => {
    const tab = key as EInsightsTab;
    localStorage.setItem(INSIGHTS_ACTIVE_TAB_KEY, tab);
    setActiveTab(tab);
  };

  const contentList: Record<EInsightsTab, React.ReactNode> = {
    [EInsightsTab.customer]: <CustomerInsights />,
    [EInsightsTab.fleet]: <FleetInsights />,
  };

  return (
    <DefaultPageLayout>
      <Card style={{ width: '100%' }} tabList={insightsTabs} activeTabKey={activeTab} onTabChange={onTabChange}>
        {contentList[activeTab]}
      </Card>
    </DefaultPageLayout>
  );
};
